"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ChangelogController = /** @class */ (function () {
    function ChangelogController(ChangelogModel, $state) {
        this.ChangelogModel = ChangelogModel;
        this.$state = $state;
        this.entries = [];
        this.pagination = { current_page: 1, last_page: 1, total: 0 };
        this.loading = false;
        this.error = "";
        this.onPageChange = this.handlePageChange.bind(this);
        this.onViewEntry = this.handleViewEntry.bind(this);
        this.fetch(1);
    }
    ChangelogController.prototype.handlePageChange = function (page) {
        this.fetch(page);
    };
    ChangelogController.prototype.handleViewEntry = function (id) {
        this.$state.go("drivecoach.admin.changelogentry", { entry_id: id });
    };
    ChangelogController.prototype.fetch = function (page) {
        var _this = this;
        this.loading = true;
        this.error = "";
        var params = { page: page };
        this.ChangelogModel.getEntries(params)
            .then(function (response) {
            _this.entries = response.entries.data;
            _this.pagination = {
                current_page: response.entries.current_page,
                last_page: response.entries.last_page,
                total: response.entries.total,
            };
            _this.loading = false;
        })
            .catch(function () {
            _this.error = "Failed to load the changelog.";
            _this.loading = false;
        });
    };
    return ChangelogController;
}());
ChangelogController.$inject = ["ChangelogModel", "$state"];
exports.default = ChangelogController;
